import { fieldStyles } from '../field-styles'
import { cn } from '@/core/utils/common'

export const choiceStyles = {
  trigger: cn(
    fieldStyles.control,
    fieldStyles.outline,
    'group flex cursor-pointer items-center gap-3 text-left data-[popup-open]:border-point aria-invalid:data-[popup-open]:border-error'
  ),
  positioner: 'z-[5000200] max-w-[calc(100vw-2rem)] outline-none',
  popup:
    'flex w-[var(--anchor-width)] max-w-[var(--available-width)] max-h-[var(--available-height)] flex-col overflow-hidden rounded-panel border border-border bg-surface-raised shadow-[var(--shadow-floating)] outline-none origin-[var(--transform-origin)] transition-[opacity,transform] duration-150 data-[starting-style]:scale-[0.98] data-[starting-style]:opacity-0 data-[ending-style]:scale-[0.98] data-[ending-style]:opacity-0',
  list: 'min-h-0 max-h-72 overflow-y-auto overscroll-contain p-1.5 outline-none',
  item: 'flex min-h-11 w-full cursor-pointer items-center gap-3 rounded-control px-3 py-2.5 text-c14 leading-5 text-foreground select-none outline-none transition-colors data-[highlighted]:bg-surface-strong data-[selected]:font-medium data-[selected]:text-point data-[disabled]:cursor-not-allowed data-[disabled]:text-description data-[disabled]:opacity-50',
} as const
